import { swRequest } from "@sourcewhale/shared/src/svelte/api/sw-request";

export const getOrganization = (organizationId) =>
  swRequest({
    path: "/api/organizations/get",
    params: { organizationId },
  });
